import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import ringtoneCallee from './ringtones/ringtoneCallee.js'

export default contract({
  ringtoneCallee: array([
    ringtoneCallee
  ]),
})